import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/pages/login')), 'login')
const home = r => require.ensure([], () => r(require('@/pages/home')), 'home')
const welcome = r => require.ensure([], () => r(require('@/pages/welcome')), 'welcome')
const createProblem = r => require.ensure([], () => r(require('@/pages/CreateProblem')), 'CreateProblem')
const fhcreateProblem = r => require.ensure([], () => r(require('@/pages/fhCreateProblem')), 'fhCreateProblem')
const examine = r => require.ensure([], () => r(require('@/pages/examine')), 'examine')
const problemList = r => require.ensure([], () => r(require('@/pages/problemList')), 'problemList')
const prepareProblemList = r => require.ensure([], () => r(require('@/pages/prepareProblemList')), 'prepareProblemList')
const prepareProblemListUser = r => require.ensure([], () => r(require('@/pages/prepareProblemListUser')), 'prepareProblemListUser')
const knowledgeList = r => require.ensure([], () => r(require('@/pages/knowledgeList')), 'knowledgeList')
const managerPage = r => require.ensure([], () => r(require('@/pages/managerPage')), 'managerPage')
const noticePage = r => require.ensure([], () => r(require('@/pages/noticePage')), 'noticePage')
const upload2Oss = r => require.ensure([], () => r(require('@/pages/upload2Oss')), 'upload2Oss')
const newTeamList = r => require.ensure([], () => r(require('@/pages/newTeamList')), 'newTeamList')

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect: { name: 'welcome' },
      children: [
        {
          path: 'welcome',
          name: 'welcome',
          component: welcome
        },
        {
          path: 'createProblem',
          name: 'CreateProblem',
          component: createProblem
        },
        {
          path: 'fhcreateProblem',
          name: 'fhCreateProblem',
          component: fhcreateProblem
        },
        {
          path: 'examine',
          name: 'examine',
          component: examine
        },
        {
          path: 'problemList',
          name: 'problemList',
          component: problemList
        },
        {
          path: 'prepareProblemList',
          name: 'prepareProblemList',
          component: prepareProblemList
        },
        {
          path: 'newTeamList',
          name: 'newTeamList',
          component: newTeamList
        },
        {
          path: 'prepareProblemListUser',
          name: 'prepareProblemListUser',
          component: prepareProblemListUser
        },
        {
          path: 'knowledgeList',
          name: 'knowledgeList',
          component: knowledgeList
        },
        {
          path: 'managerPage',
          name: 'managerPage',
          component: managerPage
        },
        {
          path: 'noticePage',
          name: 'noticePage',
          component: noticePage
        },
        {
          path: 'upload2Oss',
          name: 'upload2Oss',
          component: upload2Oss
        }
      ]
    },
    {path: '*', redirect: '/'}
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js